import "../../../chunk-D57E6H3M.mjs";

// src/components/primitive/Tooltip/tooltipTrigger.ts
import { useCallback, useEffect, useLayoutEffect, useState } from "react";
var COLD_DELAY_MS = 420;
var HANDOFF_MS = 300;
var shownCount = 0;
var lastHiddenAt = Number.NEGATIVE_INFINITY;
function isTooltipWarm() {
  return shownCount > 0 || performance.now() - lastHiddenAt < HANDOFF_MS;
}
var popups = /* @__PURE__ */ new Set();
function useTooltipShown(shown, instant = false) {
  const [wasShown, setWasShown] = useState(shown);
  const [swap, setSwap] = useState(false);
  if (shown !== wasShown) {
    setWasShown(shown);
    setSwap(shown && !instant && isTooltipWarm());
  }
  const [popup, setPopup] = useState(null);
  useEffect(() => {
    if (!popup || instant) return;
    popups.add(popup);
    return () => {
      popups.delete(popup);
    };
  }, [popup, instant]);
  useLayoutEffect(() => {
    if (!swap) return;
    for (const other of popups) {
      if (other !== popup && other.dataset.state === "closed") other.setAttribute("data-swap", "");
    }
  }, [swap, popup]);
  useLayoutEffect(() => {
    if (shown && !swap) popup?.removeAttribute("data-swap");
  }, [shown, swap, popup]);
  useEffect(() => {
    if (!shown) return;
    shownCount++;
    return () => {
      shownCount--;
      lastHiddenAt = performance.now();
    };
  }, [shown]);
  return { swap, popupRef: setPopup };
}
function resetTooltipWarmth() {
  shownCount = 0;
  lastHiddenAt = Number.NEGATIVE_INFINITY;
}
function keyboardFocusOnly(event) {
  if (!(event.target instanceof Element) || !event.target.matches(":focus-visible")) event.preventDefault();
}
function useTooltipPointer(trigger, setOpen, disabled = false, instant = false) {
  useEffect(() => {
    if (!trigger || disabled) return;
    let armed = false;
    let timer;
    const arm = () => {
      armed = true;
    };
    const cancel = () => {
      clearTimeout(timer);
      timer = void 0;
    };
    const show = () => {
      trigger.ownerDocument.dispatchEvent(new CustomEvent("tooltip.open"));
      setOpen(true);
    };
    const open = (event) => {
      if (event.pointerType === "touch") return;
      if (!instant) event.preventDefault();
      if (!armed) return;
      armed = false;
      if (instant || isTooltipWarm()) show();
      else timer = setTimeout(show, COLD_DELAY_MS);
    };
    trigger.addEventListener("pointerenter", arm);
    trigger.addEventListener("pointermove", open);
    trigger.addEventListener("pointerleave", cancel);
    trigger.addEventListener("pointerdown", cancel);
    return () => {
      cancel();
      trigger.removeEventListener("pointerenter", arm);
      trigger.removeEventListener("pointermove", open);
      trigger.removeEventListener("pointerleave", cancel);
      trigger.removeEventListener("pointerdown", cancel);
    };
  }, [trigger, setOpen, disabled, instant]);
  return useCallback(() => setOpen(false), [setOpen]);
}
export {
  keyboardFocusOnly,
  resetTooltipWarmth,
  useTooltipPointer,
  useTooltipShown
};
//# sourceMappingURL=tooltipTrigger.mjs.map